<template>
    <div class="list">
        <el-form :inline="true" size="small" :model="listQuery" class="demo-form-inline">
            <el-form-item>
                <el-input v-model="listQuery.keyword_search" clearable style="width: 190px" class="name-input" placeholder="文章名称搜索" />
            </el-form-item>

            <el-form-item label="标签筛选:" class="mr-select">
                <el-select v-model="listQuery.article_tag_id" style="width:190px" clearable>
                    <el-option v-for="(item,index) in tagList" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="状态筛选:">
                <el-select v-model="listQuery.status" style="width:190px" clearable>
                    <el-option label="全部" value=""></el-option>
                    <el-option label="显示" value="1"></el-option>
                    <el-option label="隐藏" value="2"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item class="add">
                <el-button type="primary" size="small" icon="el-icon-search" @click="getList()">筛选</el-button>
                <el-button v-if="hasHome" type="primary" size="small" icon="el-icon-plus" @click="jumpLink('home')">首页推荐设置</el-button>
                <el-button v-if="hasAdd" type="primary" size="small" icon="el-icon-plus" @click="jumpLink('add')">新建</el-button>
            </el-form-item>
        </el-form>

        <el-table v-loading="listLoading" :data="list" border style="width: 100%" align="center" size="mini">
            <el-table-column label="文章封面" align="center">
                <template slot-scope="scope">
                    <viewer v-if="scope.row.img">
                        <img :src="imgDomain + scope.row.img" class="viewer-img">
                    </viewer>
                </template>
            </el-table-column>

            <el-table-column prop="title" label="文章名称" align="center" />
            <el-table-column prop="article_class_name" label="所属分类" align="center" />
            <el-table-column prop="article_tag_name" label="所属标签" align="center" />
            <el-table-column label="状态" width="80" align="center">
                <template slot-scope="scope">
                    <span>{{ scope.row.status === 1 ? '显示' : '隐藏' }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="push_time" label="发布时间" align="center" width="160" />
            <el-table-column prop="create_time" label="创建时间" align="center" width="160" />
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button v-if="hasRecommend && scope.row.is_recommend==1" type="primary" size="mini" class="op_buttton" @click="showDialog('set',scope)">设为推荐</el-button>
                    <el-button v-if="hasCancel && scope.row.is_recommend==2" type="primary" size="mini" class="op_buttton" @click="showDialog('cancel',scope)">取消推荐</el-button></br>
                    <el-button v-if="hasHide && scope.row.status==1" type="primary" size="mini" class="op_buttton" @click="showDialog('hide',scope)">隐藏</el-button>
                    <el-button v-if="hasShow && scope.row.status==2" type="primary" size="mini" class="op_buttton" @click="showDialog('show',scope)">显示</el-button></br>
                    <el-button v-if="hasEdit" type="primary" size="mini" class="op_buttton" @click="jumpLink('edit',scope)">编辑</el-button>
                    <el-button v-if="hasDelete" type="danger" size="mini" class="op_buttton" @click="showDialog('delete',scope)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="page"><pagination v-show="total > 0" :total="total" :page.sync="listQuery.page_index" :limit.sync="listQuery.page_size" @pagination="getList" /></div>
    </div>
</template>
<script>
import { getArticleTag, getArticle, deletArticle, articleShow, articleRecommend } from '@/api/college.js';
import Pagination from '@/components/Pagination';
import CommonDialog from '@/components/CommonDialog';
import operations from '../../mixins/operations';
import { imgDomain } from '@/configs/env';
export default {
    components: { Pagination, CommonDialog },
    mixins: [operations],
    data() {
        return {
            imgDomain,
            showBtns: false,
            dialogTitle: "",
            dialogType: "",
            list: [],
            dialogVisible: false,
            total: 0,
            listQuery: {
                page_index: 1,
                page_size: 10,
                keyword_search: "",
                status: "",
                article_tag_id: ""
            },
            tagList: [],
            listLoading: false
        };
    },
    computed: {
        hasAdd() {
            return this.operations.includes('新建文章');
        },
        hasEdit() {
            return this.operations.includes('编辑文章');
        },
        hasDelete() {
            return this.operations.includes('删除文章');
        },
        hasShow() {
            return this.operations.includes('显示文章');
        },
        hasHide() {
            return this.operations.includes('隐藏文章');
        },
        hasRecommend() {
            return this.operations.includes('文章设为推荐');
        },
        hasCancel() {
            return this.operations.includes('文章取消推荐');
        },
        hasHome() {
            return this.operations.includes('文章首页推荐设置');
        }
    },

    async mounted() {
        this.getTagList();
        this.getList();
    },

    methods: {
        async getTagList() {
            const params = { page_index: 1, page_size: 999 }
            const { total, data } = await getArticleTag(params);
            this.tagList = data;
        },

        async getList(params = this.listQuery) {
            this.listLoading = true;
            const { total, data } = await getArticle(params);
            this.listLoading = false;

            this.total = total;
            this.list = data;
        },

        jumpLink(value, scope) {
            if (value == "edit") {
                this.$router.push({
                    path: "./add-article",
                    query: {
                        id: scope.row.id
                    }
                })
            } else if (value == "add") {
                this.$router.push({
                    path: "./add-article"
                })
            } else if (value == "home") {
                this.$router.push({
                    path: "./home-introduce"
                })
            }
        },

        showDialog(value, scope) {
            if (value == "delete") {
                this.$confirm(`是否删除该文章？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async() => {
                    const res = await deletArticle(scope.row.id);
                    if (res == true) {
                        this.getList();
                        this.$notify({ title: '文章删除成功', type: 'success' });
                        this.dialogVisible = false
                    } else {
                        this.$notify.error({ title: '操作失败' });
                    }
                }).catch(() => {

                })
            } else if (value == "set") {
                this.$confirm(`是否设为推荐？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: ''
                }).then(async() => {
                    const res = await articleRecommend(scope.row.id);
                    if (res == true) {
                        this.getList();
                        this.$notify({ title: '文章已设为推荐', type: 'success' });
                        this.dialogVisible = false
                    } else {
                        this.$notify.error({ title: '操作失败' });
                    }
                }).catch(() => {

                })
            } else if (value == "cancel") {
                this.$confirm(`是否取消推荐？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: ''
                }).then(async() => {
                    const res = await articleRecommend(scope.row.id);
                    if (res == true) {
                        this.getList();
                        this.$notify({ title: '文章已取消推荐', type: 'success' });
                        this.dialogVisible = false
                    } else {
                        this.$notify.error({ title: '操作失败' });
                    }
                }).catch(() => {

                })
            } else if (value == "show") {
                this.$confirm(`是否显示该文章？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: ''
                }).then(async() => {
                    const res = await articleShow(scope.row.id);
                    if (res == true) {
                        this.getList();
                        this.$notify({ title: '文章已显示', type: 'success' });
                        this.dialogVisible = false
                    } else {
                        this.$notify.error({ title: '操作失败' });
                    }
                }).catch(() => {

                })
            } else if (value == "hide") {
                this.$confirm(`是否隐藏该文章？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: ''
                }).then(async() => {
                    const res = await articleShow(scope.row.id);
                    if (res == true) {
                        this.getList();
                        this.$notify({ title: '文章已隐藏', type: 'success' });
                        this.dialogVisible = false
                    } else {
                        this.$notify.error({ title: '操作失败' });
                    }
                }).catch(() => {

                })
            }
        }
    }
};
</script>

<style lang="less" scoped>
    .list{
        .add{
            float: right;
            margin-bottom: 20px;
        }
        .button_wrap{
            text-align: center;
            margin-top: 30px;
        }
        .el-form-item:last-child{
            margin-bottom: 0;
        }
        .demo-form-inline{
            /deep/ .el-form-item{
                margin-right: 0;
            }
            /deep/.mr-select{
                margin: 0 20px;
            }
        }
        .op_buttton{
            margin-bottom: 10px;
        }
        .viewer-img{
            width: 124px;
            height: 80px;
        }

    }
</style>
